module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};



/*****************
 ** WEBPACK FOOTER
 ** /Users/cdrobish/Development/ChadAndrewDrobish/four32c/holiday-map/development/~/page/~/path-to-regexp/~/isarray/index.js
 ** module id = 8
 ** module chunks = 0
 **/